<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="scanDocument"
    @on-cancel="hide()"
    :okText="$t('Scan')"
    :closeText="$t('Close')"
  >
    <v-row justify="center" align="center" v-if="loading">
      <div class="text-center">
        <div>
          <v-progress-circular
            class="my-4"
            :size="50"
            width="5"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <p class="display-1">{{ $t("Loading") }}...</p>
      </div>
    </v-row>
    <v-form class="mt-5" v-if="!loading">
      <v-select
        v-if="serviceOk"
        :loading="loadingList"
        v-bind:label="$t('Scanner')"
        v-model="scanner"
        :error-messages="scannerErrors"
        @input="$v.scanner.$touch()"
        @blur="$v.scanner.$touch()"
        :items="scannerList"
        item-text="text"
        item-value="id"
        return-object
      />
      <p v-if="!serviceOk">
        {{ $t("DocWebScanNotAvailable") }}
        <a href="/static/DocWebScan/Doc.WebScan.msi" download="">{{
          $t("Here")
        }}</a>
      </p>
      <p v-if="!serviceOk">
        <a href="#" @click="ping">{{ $t("Refresh") }}</a>
      </p>
    </v-form>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import DocWebScanService from "@/services/DocWebScanService";
import DocumentService from "@/services/DocumentService";
import Utils from "@/ecm/common/Utils";

export default {
  data() {
    return {
      modal: {
        title: this.$t("ScanDocument"),
        key: "scanDocumetnMoal",
      },
      open: false,
      scanner: null,
      serviceOk: false,
      loading: false,
      loadingList: false,
      scannerList: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    scanner: { required },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return this.modal.title;
    },
    scannerErrors() {
      const errors = [];
      if (!this.$v.scanner.$dirty) return errors;
      !this.$v.scanner.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    scanDocument() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      var data = {
        source: {
          sourceName: this.scanner.id,
          outputFormat: "pdf",
          sourceConfig: {
            enableCustomConfiguration: false,
            selectFeeder: true,
            resolution: 200,
            bitDepth: 24,
            enableDuplex: false,
            hideUI: true,
            acquisitionFormat: "pdf",
            extConfig: null,
          },
        },
      };

      var port = this.scanner.is64bit ? 56858 : 56857;
      DocWebScanService.getDocument(data, port)
        .then((result) => {
          this.modalInstance.progress(false);
          if (
            result.TwainAcquire2Result &&
            result.TwainAcquire2Result.fileSize > 0
          ) {
            this.saveAttachment(result.TwainAcquire2Result);
          } else {
            Utils.toast.error(this.$t("ScanError"));
          }
        })
        .catch((error) => {
          this.modalInstance.progress(false);
        });
    },
    saveAttachment(fileResult) {
      var attachmentDto = {
        File: fileResult.fileData,
        FileName: fileResult.fileName,
      };

      DocumentService.uploadScannedAttachment(attachmentDto)
        .then((result) => {
          let attachment = {
            fileId: result.id,
            fileName: fileResult.fileName,
            isLoading: false,
            size: fileResult.fileSize,
            extension: "pdf",
            thumbnail: Utils.file.image.generateAvatar("pdf", 150),
          };
          this.$emit("on-scanned", attachment);
          this.hide();
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    loadScanners() {
      this.loadingList = true;
      DocWebScanService.getList()
        .then((data) => {
          if (data.GetTwainSourcesResult) {
            this.scannerList = data.GetTwainSourcesResult.sources.map((s) => {
              return {
                id: s.sourceName,
                text: s.sourceName,
                is64bit: s.is64bit,
              };
            });
            if (data.GetTwainSourcesResult.defaultSource) {
              this.scanner = this.scannerList.filter(
                (f) => f.id == data.GetTwainSourcesResult.defaultSource
              )[0];
            }
          }
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
        });
    },
    ping() {
      this.loading = true;
      DocWebScanService.ping()
        .then((data) => {
          this.serviceOk = data.PingResult == "pong";
          if (this.serviceOk) this.loadScanners();
          this.loadScanners();
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    show() {
      this.$v.$reset();
      this.open = true;
      this.ping();
    },
    hide() {
      this.open = false;
    },
  },
};
</script>